import { Backdrop, Button, Modal, Paper } from "@material-ui/core";
import styled from "styled-components";

import CloseIcon from "@material-ui/icons/Close";
import FontStyles from "../../styles/fontStyles";

const StyledBackdrop = styled(Backdrop)({
  backdropFilter: "blur(5px)",
  WebkitBackdropFilter: "blur(5px)",
  backgroundColor: "#00000020",
});

const StyledModal = styled(Modal)({
  outlineWidth: 0,
  borderWidth: 0,
  overflow: "hidden",
  ":focus": {},
});

const Container = styled(Paper)(({ theme, noMaxWidth }) => {
  const { spacing } = theme;
  return {
    position: "absolute",
    width: "auto",
    maxWidth: noMaxWidth ? "60vw" : 470,
    maxHeight: "90vh",
    paddingBlock: spacing(3),
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    outline: "none",
    backgroundColor: "#FFFFFF",
    overflowY: "auto",
  };
});

const ContentContainer = styled.div(({ theme }) => {
  return {
    overflow: "hidden",
  };
});

const HeaderContainer = styled.div(({ theme, noExit }) => {
  const { spacing } = theme;
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInline: spacing(3.12),
    // marginTop: noExit ? spacing(1.5) : spacing(0.5),
  };
});

const Close = styled(CloseIcon)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    color: colors.carbon,
    width: spacing(3),
    height: spacing(3),
  };
});

const TextContainer = styled.div(({ theme }) => {
  const { spacing } = theme;
  return {
    color: "black",
    paddingBottom: spacing(1),

    textAlign: "center",
    [`@media only screen and (max-height: 700px)`]: {
      padding: 0,
      margin: 0,
    },
  };
});
const PaddingModal = styled.div(({ theme }) => {
  const { spacing } = theme;
  return {
    paddingInline: spacing(3.5),
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
    alignItems: "center",
  };
});
const ContentText = styled.p(({ theme, first }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium16,
    color: colors.text.primary,
    textAlign: "justify",
    paddingInline: spacing(3.12),
    marginBottom: !first ? spacing(1) : spacing(2),
    marginTop: spacing(1),
  };
});
const Title = styled.p(({ theme }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.bold18,
    color: colors.text.secondary,
    margin: 0,
    padding: 0,
  };
});
const FooterContainer = styled.div(({ theme }) => {
  const { spacing } = theme;
  return {
    marginTop: spacing(1),
    paddingInline: spacing(3.5),
    display: "flex",

    justifyContent: "flex-start",
    alignItems: "center",
  };
});

const ConfirmButton = styled(Button)(({ theme }) => {
  const { spacing, palette: colors } = theme;
  return {
    width: "auto",
    marginLeft: spacing(2),

    "& .MuiButton-label": {
      ...FontStyles.bold14,
      color: colors.text.secondary,
    },
  };
});

const ExitButton = styled(Button)(({ theme }) => {

  return {
    ...FontStyles.bold12,

    textTransform: "capitalize",
    "& .MuiButton-label": {
      ...FontStyles.bold14,
    },
  };
});

const Styles = {
  StyledBackdrop,
  StyledModal,
  Container,
  ContentContainer,
  HeaderContainer,
  Close,
  TextContainer,
  PaddingModal,
  ContentText,
  Title,
  FooterContainer,
  ConfirmButton,
  ExitButton,
};

export default Styles;
